import { debug } from '../../common/environment-utils';
import { UserContextErrorCodes } from './UserContextErrorCodes';
// Does the user have ANY of the required roles?
function hasRequiredRole(permittedRoles, user) {
    return permittedRoles.length === 0 || permittedRoles.some((role) => user.roles[role]);
}
// Does the user have ALL of the required features?
function hasRequiredFeature(requiredFeatures, enabledFeatures) {
    return requiredFeatures.every((requiredFeature) => enabledFeatures.includes(requiredFeature));
}
// Does the user have ALL of the required Modules?
function hasRequiredModule(requiredModules, user) {
    return requiredModules.every((requiredModule) => user.modules[requiredModule]);
}
export function userContextReducer(state, action) {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'errorCode':
            newState.errorCode = action.errorCode;
            newState.loading = false;
            break;
        case 'setUser':
            newState.user = action.user;
            if (state.permittedRoles && !hasRequiredRole(state.permittedRoles, newState.user)) {
                debug(`User does not have at least one of the required roles: ${state.permittedRoles.join(' ')}`);
                newState.errorCode = UserContextErrorCodes.INCORRECT_ROLE;
                newState.loading = false;
            }
            if (state.requiredModules && !hasRequiredModule(state.requiredModules, newState.user)) {
                debug(`User does not have all of the required modules: ${state.requiredModules.join(' ')}`);
                newState.errorCode = UserContextErrorCodes.INCORRECT_MODULE;
                newState.loading = false;
            }
            break;
        case 'setFeatures':
            newState.features = action.features;
            if (newState.requiredFeatures &&
                !hasRequiredFeature(newState.requiredFeatures, newState.features.enabledFeatures)) {
                debug(`User does not have all of the required features enabled: ${state.requiredFeatures.join()}`);
                newState.errorCode = UserContextErrorCodes.INCORRECT_FEATURES;
                newState.loading = false;
            }
            break;
        default:
            throw new Error('Invalid action in user context reducer');
    }
    if (newState.features && newState.user) {
        newState.loading = false;
    }
    return newState;
}
//# sourceMappingURL=userContextReducer.js.map